import React from 'react'
import { Field } from 'redux-form'
import { Input, Select } from '../../../../../../../../../../itrust_common/components/form'
import { required } from '../../../../../../../../../../itrust_common/components/form/FormValidations'

function toDropdownOptions(configs) {
  if (!Array.isArray(configs)) return []
  return configs.map((item) => {
    if (typeof item === 'string') return { label: item, value: item }
    const value = item.value ?? item.code ?? item.name ?? item.label
    return { label: item.label || item.name || String(value), value }
  }).filter((item) => item.value !== undefined && item.value !== null && item.value !== '')
}

function SpecialParametersFields({ loading, fields }) {
  if (loading) {
    return (
      <div className="border rounded p-5 mt-4 d-flex align-items-center">
        <span className="spinner-border spinner-border-sm text-primary mr-2" />
        <span>Loading Special Parameters...</span>
      </div>
    )
  }

  if (!fields.length) {
    return (
      <div className="border rounded p-5 mt-4">
        <h5 className="mb-0 font-weight-bold">Special Parameters</h5>
        <p className="mb-0 mt-3 text-muted">No special parameters available for the selected lens.</p>
      </div>
    )
  }

  const sorted = [...fields].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))

  return (
    <div className="border rounded p-5 mt-4">
      <h5 className="mb-4 font-weight-bold">Special Parameters</h5>
      <div className="row">
        {sorted.map((param) => {
          const name = `special_parameters.${param.xmlParameterName}`
          const options = toDropdownOptions(param.dropDownConfigs)
          const isDropdown = options.length > 0

          return (
            <div key={param.parameterId || param.xmlParameterName} className="col-6 mb-4">
              <label className="d-block mb-2">
                {param.labelName}
                {param.mandatory && <span className="text-danger ml-1">*</span>}
              </label>
              {isDropdown ? (
                <Field
                  name={name}
                  component={Select}
                  data={options}
                  textField="label"
                  valueField="value"
                  className="custom-select"
                  wrapperClasses="mb-0"
                  validate={param.mandatory ? [required] : []}
                />
              ) : (
                <Field
                  name={name}
                  component={Input}
                  className="form-control"
                  wrapperClasses="mb-0"
                  validate={param.mandatory ? [required] : []}
                />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SpecialParametersFields
